import {
  type EnvironmentProviders,
  Injectable,
  LOCALE_ID,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core'
import {type Observable, of} from 'rxjs'
import {AppSessionService} from '@services/app-session.service'
import {provideTransloco} from '@uve-solutions/composition/translate'
import {UveI18nService} from './uve-i18n.service'

export const UVE_I18N_AVAILABLE_LANGS = ['en', 'es', 'ca', 'fr', 'de', 'it', 'pt', 'zh']

const UVE_TRANSLOCO_CONFIG = {
  defaultLang: 'es',
  reRenderOnLangChange: true,
  availableLangs: UVE_I18N_AVAILABLE_LANGS,
  fallbackLang: 'en',
  failedRetries: 4,
  missingHandler: {useFallbackTranslation: false},
  prodMode: true,
}

/* Las libs @uve-solutions (f-chat, f-gallery, ui/setup) traen sus traducciones en scopes
 * transloco propios; cart no tiene traducciones transloco de raíz (usa ngx-translate). */
@Injectable({providedIn: 'root'})
export class EmptyTranslocoLoader {
  getTranslation(): Observable<Record<string, never>> {
    return of({})
  }
}

export function provideUveI18n(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideTransloco({config: UVE_TRANSLOCO_CONFIG, loader: EmptyTranslocoLoader}),
    {
      provide: LOCALE_ID,
      deps: [AppSessionService],
      useFactory: (session: AppSessionService) => session.currentUser?.language || 'en',
    },
    provideAppInitializer(() => inject(UveI18nService).init()),
  ])
}

export function provideUveI18nForTesting(): EnvironmentProviders {
  return makeEnvironmentProviders([provideTransloco({config: UVE_TRANSLOCO_CONFIG, loader: EmptyTranslocoLoader})])
}
